import type { Component, Entity2D } from '../../odie';

import type { RainbowBubbleBlockProps } from '../defs/block';
import { RainbowBubbleBlockView } from '../views/blocks/RainbowBubbleBlockView';

export type RainbowBubbleBlockComponentOptions = {
  props: RainbowBubbleBlockProps;
};

export class RainbowBubbleBlockComponent implements Component {
  public static readonly NAME = 'blockRainbowBubble';
  public entity!: Entity2D;
  public view!: RainbowBubbleBlockView;

  public init(options: RainbowBubbleBlockComponentOptions): void {
    this.view = new RainbowBubbleBlockView(options.props);
  }
}
